import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
export var LightShadow = /*#__PURE__*/function () {
  function LightShadow() {
    _classCallCheck(this, LightShadow);
    this.color = new OptionsColor();
    this.color.value = "#000000";
    this.length = 2000;
  }
  _createClass(LightShadow, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      this.color = OptionsColor.create(this.color, data.color);
      if (data.length !== undefined) {
        this.length = data.length;
      }
    }
  }]);
  return LightShadow;
}();